import React, { useState } from 'react';
import QuizModal from '../../components/AdminPortal/Quizzes/QuizModal';
import QuizRow from '../../components/AdminPortal/Quizzes/QuizRow';
import { useGetQuizzesQuery } from '../../features/quiz/quizApi';

const Quizzes = ({}) => {
    const [opened, setOpened] = useState(false);

    const controlModal = () => {
        setOpened((prevState) => !prevState);
    };

 const {data:quizzes, isLoading, isError} = useGetQuizzesQuery();

  let content;

  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>Something went wrong</div>;
  }
  if (!isLoading && !isError && quizzes.length === 0) {
    content = <div>No quiz available</div>;
  }
  if (!isLoading && !isError && quizzes.length > 0) {
    content = quizzes.map((quiz) => <QuizRow key={quiz.id} quiz={quiz} control={controlModal} open={opened}/>);
  }
    return (
        <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20 relative"> 
        
          <div className="px-3 py-20 bg-opacity-10">
          
            <div className="w-full flex ">
             {!opened &&  <button className="btn ml-auto" onClick={controlModal}>Add Quiz</button>}
            </div>
           <QuizModal open={opened} control={controlModal}/>
            <div className="overflow-x-auto mt-4">
            
            <table className="divide-y-1 text-base divide-gray-600 w-full">
                        <thead>
                            <tr>
                                <th className="table-th">Question</th>
                                <th className="table-th">Video</th>
                                <th className="table-th justify-center">Action</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-slate-600/50">
                           {content} 
                        </tbody>
                    </table>
            </div>
          </div>
        </div>
  
       
      </section>
    );
};

export default Quizzes;